import antdKR from "antd/locale/ko_KR";
import enMessages from "../locales/ko_KR.json";

const KoLang = {
  messages: {
    ...enMessages
  },
  antd: {
    ...antdKR,
    DatePicker: {
      ...antdKR.DatePicker,
      lang: {
        ...antdKR.DatePicker.lang,
        dayFormat: 'D',
      }
    }
  },
  locale: 'ko-KR',
};
export default KoLang;
